module.exports = __webpack_public_path__ + "img/brandv-2.ce2f5de5.jpg";